import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { LoadingProvider, useLoading } from '../contexts/LoadingContext';
import Header from '../components/landing/Header';
import HeroCarousel from '../components/landing/HeroCarousel';
import WhyHaazri from '../components/landing/WhyHaazri';
import HowItWorks from '../components/landing/HowItWorks';
import FeaturesSection from '../components/landing/FeaturesSection';
import BlogsSection from '../components/landing/BlogsSection';
import PricingSection from '../components/landing/PricingSection';
import Testimonials from '../components/landing/Testimonials';
import CTASection from '../components/landing/CTASection';
import FAQ from '../components/landing/FAQ';
import ContactInfo from '../components/landing/ContactInfo';
import SocialMediaSection from '../components/landing/SocialMediaSection';
import Footer from '../components/landing/Footer';
import FloatingHelpButton from '../components/landing/FloatingHelpButton';
import ChatWidget from '../components/ChatWidget/ChatWidget';
import SEOHead from '../components/SEOHead';
import DynamicFavicon from '../components/DynamicFavicon';
import './LandingPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const LandingPageContent = () => {
  const [seoConfig, setSeoConfig] = useState({});
  const { isLoading } = useLoading();

  useEffect(() => {
    fetchSEOConfig();
  }, []);

  const fetchSEOConfig = async () => {
    try {
      const response = await axios.get(`${API_URL}/landing_page_api.php`);
      if (response.data.status === 'success') {
        const config = response.data.data.config || {};
        setSeoConfig(config);
      }
    } catch (error) {
      console.error('Failed to fetch SEO config:', error);
    }
  };

  return (
    <div className="landing-page">
      <SEOHead config={seoConfig} />
      <DynamicFavicon />

      {isLoading && (
        <div className="page-loader">
          <div className="loader-content">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      )}

      <div className={isLoading ? 'page-hidden' : 'page-visible'}>
        <Header />
        <HeroCarousel />
        <WhyHaazri />
        <HowItWorks />
        <FeaturesSection />
        <BlogsSection />
        <PricingSection />
        <Testimonials />
        <CTASection />
        <FAQ />
        <ContactInfo />
        <SocialMediaSection />
        <Footer />
        <FloatingHelpButton />
        <ChatWidget />
      </div>
    </div>
  );
};

const LandingPage = () => {
  return (
    <LoadingProvider>
      <LandingPageContent />
    </LoadingProvider>
  );
};

export default LandingPage;
